import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMainContext } from "../../../Context";
import { useQuery } from "../../../Hooks";
import { nesdata, provinces, cities } from "../../../Utils/Apis";

export const useCities = () => {
  const [form, setForm] = useState({
    selected: {},
  });
  const {
    post,
    dispatch,
    state: { city },
  } = useMainContext();
  const [init, setInint] = useState({});
  const [loading, setLoading] = useState({ province: true, city: false });
  const [province, setPorvince] = useState([]);
  const [citys, setCitys] = useState([]);
  const { searchParams, changeObj, getValue } = useQuery({
    filters: [{ key: "province_id" }],
  });
  const navigate = useNavigate();

  const getProvince = async () => {
    setLoading({ province: true });

    const { data } = await post(provinces);
    if (data) {
      setPorvince(data);
    }
    setLoading({ province: false });
  };

  const getCity = async () => {
    setLoading({ city: true });

    const { data } = await post(cities, {
      province_id: getValue("province_id"),
    });
    if (data) {
      setCitys(data);
    }
    setLoading({ city: false });
  };
  useEffect(() => {
    getProvince();
  }, []);
  useEffect(() => {
    if (getValue("province_id")) {
      getCity();
    }
  }, [searchParams]);
  return {
    citys,
    form,
    setForm,
    province,
    loading,
    getValue,
    changeObj,
    dispatch,
    city,
    navigate,
  };
};
